import { createSignal } from '@verclam/pulsar';

/** `true` while the document fills the whole window (CSS layout, plus the browser's fullscreen when available). */
const documentFullscreenSignal = createSignal<boolean>(false);

export const setDocumentFullscreen = (isFullscreen: boolean): void => {
	documentFullscreenSignal.value = isFullscreen;
};

export default documentFullscreenSignal;
